import getApiClient from '@/plugins/api-client'

export default {
    loadProfiles() {
        const self = this,
            api = getApiClient(self.$store),
            userId = self.$route.params.id

        if (['xs', 'sm', 'md'].includes(self.$vuetify.breakpoint.name)) {
            self.$vuetify.goTo(0)
        }

        api.get(`/work_profiles?user.id=${userId}`)
          .then(result => {
              self.profiles = result.data['hydra:member']
          })
    },

    goToJobCreation() {
        this.$router.push({
            name: 'ContractorJobForm'
        })
    },

    showMedia(media, index) {
        this.showZoomMedia = true
        this.zoomMedia = media
        this.currentMedia = index
    },

    closeMedia() {
        this.zoomMedia = null
        this.showZoomMedia = false
    },

    toggleFavorite(id) {
        const self = this,
            api = getApiClient(self.$store)

        let favorites = self.$store.state.session.favoriteWorkProfiles,
            favoriteIds = favorites.map(profile => {
                return profile['@id']
            })

        if (!favoriteIds.includes(id)) {
            favoriteIds.push(id)
        } else {
            favoriteIds = favoriteIds.filter(profileId => {
                return profileId !== id
            })
        }

        api.patch(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`, {favoriteWorkProfiles: favoriteIds}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
            })
            .catch(error => {
                console.log(error)
            })
    },

    getPastJobTypeLabel(type) {
        let item = this.allAvailableJobTypes.filter(item => {
            return item.code === type
        })

        return item[0]?.label ?? type
    },

    getLanguageLabel(language) {
        let item = this.availableLanguages.filter(item => {
            return item.value === language
        })

        return item[0]?.label ?? language
    },

    getEducationLevelLabel(level) {
        let item = this.availableEducationLevels.filter(item => {
            return item.value === level
        })

        return item[0]?.label ?? level
    },

    exportProfile() {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`users/pdf/${self.profiles[0].user.id}`, {responseType: 'blob'})
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data])),
                    link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${self.profiles[0].user.name} - Perfil na Castfy.pdf`)
                document.body.appendChild(link)
                link.click()
            })
            .catch(error => {
                console.log(error)
            })
    },


    showCompletedCourseDetails(course) {
        this.completedCourseDetails = {
            ...course,
            show: true
        }
    },

    hideCompletedCourseDetails() {
        this.completedCourseDetails = {
            show: false,
            image: null,
            name: null,
            description: null
        }
    },

    getProfileHeader(profile) {
        const headers = {
            'casting': 'Casting <span>Recepcionistas, promotores, credenciamento, supervisão, modelo para lookbook</span>',
            'event_support': 'Apoio para eventos <span>Coordenação, produção, apoio, segurança, carregador, limpeza</span>',
            'bars_restaurants': 'Bares e Restaurantes <span>Hostess, garçom/garçonete, bartender, cozinheiro(a)</span>',
            'master_of_ceremonies': 'Mestre de Cerimônias <span>apresentador, mediador, celebrante</span>'
        }
        return headers[profile.category]
    },

    copyLinkToClipboard: function() {
        navigator.clipboard.writeText(location.href);
        this.copyToClipboardTooltip = 'Link copiado!'
        window.setTimeout(() => {
            this.copyToClipboardTooltip = 'Copiar link'
        }, 2000)
    },
}
